// Dependencies
import { all, call, takeEvery, fork, put } from "@redux-saga/core/effects";

// Action Types
import {
    JIRA_SUMMARY_SEARCH_REQUEST,
    ACTIVITIES_GET_USERS_REQUEST,
} from 'Redux/actionTypes';

// Actions
import {
    jiraSummarySearchResult,
    activitiesSearchUsersResult,
} from 'Redux/actions';

// Helpers
import { clientQuery } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';

function* searchJiraSummaries({ payload }) {
    try {
        let QUERY = `
                query searchJiraSummary ($dateRange: AWSDateTimeRange!, $developer: String, $jiraTask: String) {
                    result: searchJiraSummary (dateRange: $dateRange, developer: $developer, jiraTask: $jiraTask) {
                        name
                        country
                        daysPeriod
                        tasksPeriod
                        taskPeriodGSD
                        taskPeriodOthers
                        totalTimeHours
                        totalTimeHoursGSD
                        totalTimeHoursOthers
                        totalStoryPoints
                        totalStoryPointsGSD
                        totalStoryPointsOthers
                        totalRejectedTasks
                        totalRejections
                        tasksPeriodBugsResponsible
                        totalTimeHoursBugs
                        totalStoryPointsBugs
                        tasksPeriodBugs
                        kpi {
                            quality
                            estimation
                            participation
                            total
                        }
                    }
                }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );
        if (data?.result) {
            yield put(jiraSummarySearchResult(data?.result))
        }else{
            yield put(jiraSummarySearchResult([]))
        }
    } catch (exc) {
        yield put(jiraSummarySearchResult([]));
        ExceptionManager(exc, 'Modules/pmUsers/views/jiraSummary/redux/saga', 'searchJiraSummaries');
    }
}





function* watchMethods() {
    yield takeEvery(JIRA_SUMMARY_SEARCH_REQUEST, searchJiraSummaries);
    
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}